module.exports = __webpack_public_path__ + "img/kefu_code.0a99337c.png";